<template>
    <div class="consultation-header">
        <div class="header-first">
            <div style="text-align:center;font-family: Microsoft YaHei;font-weight: bold;color: #272727;margin-top:15px;font-size:22px"><span>院前急救</span></div>
        </div>
        <div class="header-second">
            <div style="font-family: Microsoft YaHei;font-weight: bold;color: #4E4E4E;font-size:18px;margin-bottom:20px"><span>产品简介</span></div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;margin-top:20p;text-indent:30px;">
                			院前急救可视化系统实现院前救治情况同步实时传输，并使院前院内无缝连接，数据自动上传及共享，自动生成覆盖院前的急诊病例，院内急救中
            </div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px">心远程指导院前急救的诊治。院前急救系统包括救护车定位追踪、呼救位置显示、移动数据传输和5G高清视频沟通。救护车辆安装车载地理位置通讯设 </div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px">备，确保与急救中心、医院急诊科之间实现实时数据互通及音视频实时传输。按照就近、就急、满足专业需要、兼顾患者意愿和平台资源地图的原则，合</div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px">理制定患者转诊方案和转诊路线。</div>
            <div style="margin-top:30px">
                <img src="@/assets/image/jiu.png" alt="">
            </div>
        </div>
        <div class="header-firth" style="margin-top:20px">
            <div style="font-family: Microsoft YaHei;font-weight: bold;color: #4E4E4E;font-size:18px"><span>产品框架</span></div>
            <div style="margin-top:20px">
                <img src="@/assets/image/jiu1.png" alt="">
            </div>
        </div>
        <div class="header-forth">
            <div style="font-family: Microsoft YaHei;font-weight: bold;color: #4E4E4E;font-size:18px;margin-top:10px"><span>应用亮点</span></div>
            <div style="display:flex;justify-content:space-between;margin-top:20px;flex-wrap: wrap">
                <el-card style="width:48.1%;height:140px;border:2px solid #eee;background: #FFFFFF;display: flex;align-items: center">
                    <div style="display:flex;">
                        <div  >
                            <img src="@/assets/image/ytanshi.png" alt="" style="padding-top:10px">
                        </div>
                        <div style="padding-left:15px;padding-top:10px">
                            <div style="font-size: 16px;font-family: Microsoft YaHei;font-weight: 400;color: #000000;"><span>智能化</span></div>
                            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #6A6A6A;font-size:14px;padding-top:5px;"><span>根据患者算在位置，自动搜索和智能推荐急救车辆，合理化急救安排</span></div>
                        </div>
                    </div>
                </el-card>
                <el-card style="width:48.1%;height:140px;border:2px solid #eee;display: flex;align-items: center">
                            <div style="display:flex;">
                        <div style="vertical-align:middle">
                            <img src="@/assets/image/tu1.png" alt="" style="margin-top:18px">
                        </div>
                        <div style="padding-left:15px;margin-top:18px">
                            <div style="font-size: 16px;font-family: Microsoft YaHei;font-weight: 400;color: #000000;"><span>网络适应性</span></div>
                            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #6A6A6A;font-size:14px;padding-top:5px;"><span>支持双5G卡自适应传输，有效避免急救车运输过程中网络不稳定对急救影像</span></div>
                        </div>
                    </div>
                </el-card>
                <el-card style="width:48.1%;height:140px;border:2px solid #eee;background: #FFFFFF;margin-top:25px;display: flex;align-items: center">
                                    <div style="display:flex;">
                        <div style="vertical-align:middle">
                            <img src="@/assets/image/jtu1.png" alt="" style="padding-top:8px">
                        </div>
                      <div style="padding-left:15px;">
                            <div style="font-size: 16px;font-family: Microsoft YaHei;font-weight: 400;color: #000000;padding-top:5px"><span>融合性</span></div>
                            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #6A6A6A;font-size:14px;padding-top:8px"><span>集成医院HIS系统和急救车上生命体征仪等医疗监测设备，让院内实时了解患者情况</span></div>
                        </div>
                    </div>
                </el-card>
                <el-card style="width:48.1%;height:140px;border:2px solid #eee;margin-top:25px;display: flex;align-items: center">
                        <div style="display:flex;">
                        <div style="vertical-align:middle">
                            <img src="@/assets/image/yan.png" alt="" style="padding-top:5px">
                        </div>
                       <div style="padding-left:15px;">
                            <div style="font-size: 16px;font-family: Microsoft YaHei;font-weight: 400;color: #000000;"><span>可视化</span></div>
                            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #6A6A6A;font-size:14px;padding-top:5px;"><span>支持GIS地图，一张图可视化管理急救车、急救任务，及时支持急救过程</span></div>
                        </div>
                    </div>
                </el-card>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss">
    .consultation-header{
        width: 100%;
        padding-left: 20px;
        .header-forth{
            margin-right:70px;
        }

    }
</style>